<template>
	<page>
		<module>
			<view-list ref="view" work-type="7" selector :view-config="auth('b_asset_receive_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="资产领用单号">
							<c-input name="apply_code"></c-input>
						</m-search-item>
                        <m-search-item label="售后申请单号">
                            <c-input name="aftersale_order_no"></c-input>
                        </m-search-item>
                        <m-search-item label="领用人">
                            <c-input name="apply_user_name" placeholder="请输入领用人"></c-input>
                        </m-search-item>
                        <m-search-item label="领用资产">
                            <c-input name="keyword" placeholder="请输入资产编号或名称"></c-input>
                        </m-search-item>
                        <m-search-item label="所属网点">
                            <c-select name="after_sale_outlet_id" async @search="searchOutlet"></c-select>
                        </m-search-item>
						<m-search-item label="状态">
                            <c-select name="apply_status" :options="applyStatusDic"  multiple></c-select>
						</m-search-item>
					</m-search>
				</template>
                <template #operate="{data}">
                    <c-button v-if="auth('b_asset_receive_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>

                </template>
                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_asset_receive_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                <!--单据编号-->
                <template #apply_code="{data}">
                    <c-link @click="globalDialog('assetReceiveApplyDetail', {props: {id: data.id}})">{{data.apply_code}}</c-link>
                </template>

                <!--状态-->
                <template #apply_status="{data}">
                    <c-state dict="applyStatusDic" :value="data.apply_status"></c-state>
                </template>

                <!--状态-->
                <template #urgency_level="{data}">
                    <c-state dict="urgencyLevelDic" :value="data.urgency_level"></c-state>
                </template>

				<c-table-column
					type="button"
					label="操作"
					width="250"
					button-limit="4"
				>
					<template #default="{data}">
                        <c-table-button icon="tf-detail" @click="globalDialog('assetReceiveApplyDetail', {props: {id: data.id}}, $refs.view.$refs.list.update)">查看</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		components: {

        },
		computed: {
			// 获取dictName选项数据
			...mapState(['applyStatusDic']),
		},

		data() {
			return {
				defaultSearchData: {

				},
			}
		},

		methods: {
			/*******搜索网点*****************/
			searchOutlet(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'AFTERSALE_OUTLET',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>